export default "__VITE_ASSET__oQGtprVY__"